import { AxiosInstance } from "axios";

import {
  GetGitbookDocsRequestI,
  GetGitbookDocsResponseI,
} from "@/api/routes/docs/interfaces";

export const DocsAPIEndpoints = (API: AxiosInstance) => ({
  fetchGitbookDocs: ({ spaceId, path }: GetGitbookDocsRequestI) =>
    API.get<GetGitbookDocsResponseI>(
      `/v1/docs/gitbook/space/${spaceId}?path=${encodeURIComponent(path)}`
    ),
});
